// @ts-nocheck
import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
import { BsCaretDownFill, BsThreeDotsVertical } from "react-icons/bs";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { COMPANY_URLS } from "../../../Utils/Company_App_Urls";
import "./BillingInvoices.css";
import axios from "axios";

export default function BillingInvoices() {
  const [filterOption, setFilterOption] = useState({
    invoiceId: false,
    billingDate: false,
    plan: false,
    amount: false,
    status: false,
  });
  const [invoiceData, setInvoiceData] = useState([]);
  const [error, setError] = useState(null);

  const [activePlan, setActivePlan] = useState({
    planName: "",
    activatedSince: "",
    amount: 0,
    duration: "Month",
    expiredAt: "",
    condition: "",
  });

  useEffect(() => {
    const fetchActivePlan = async () => {
      try {
        const response = await axios.get(COMPANY_URLS.getActivePlan, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            Accept: "application/json",
          },
        });

        console.log("Full API response:", response);
        console.log("Response data structure:", response.data);

        if (response.data && response.data.data) {
          const planData = response.data.data;
          console.log("Plan data:", planData);

          const activePlanData = Array.isArray(planData)
            ? planData[0]
            : planData;

          setActivePlan({
            planName: activePlanData?.planName || "Free plan",
            condition: activePlanData?.condition,
            activatedSince: activePlanData?.startedAt
              ? new Date(activePlanData.startedAt).toLocaleDateString("en-US")
              : "Null",
            amount: activePlanData?.amount || 0,
            duration: activePlanData?.duration || "Month",
            expiredAt: activePlanData?.expiredAt
              ? new Date(activePlanData.expiredAt).toLocaleDateString("en-US")
              : "Null",
          });
        } else {
          console.log("No active plan data found in response");
        }
      } catch (err) {
        console.error("Error fetching active plan:", err);
      }
    };

    const fetchInvoiceData = async () => {
      try {
        const response = await axios.get(COMPANY_URLS.getAllPayment, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            Accept: "application/json",
          },
        });
        const transformedData = response.data.data.map((item) => ({
          invoiceId: item.merchantTransactionId,
          date: new Date(item.createdAt).toLocaleDateString(),
          plan: item.planName,
          amount: item.amount,
          status: item.status,
          _id: item._id,
        }));

        setInvoiceData(transformedData);
      } catch (err) {
        setError(err.message);
        console.error("Error", err);
      }
    };

    fetchActivePlan();
    fetchInvoiceData();
  }, []);

  const handleOptionToggle = (option) => {
    setFilterOption((prev) => ({
      ...Object.fromEntries(Object.keys(prev).map((key) => [key, false])),
      [option]: !prev[option],
    }));
    handleFilterByOption(option);
  };

  const handleFilterByOption = (option) => {
    const sortedData = [...invoiceData];

    const sortFunctions = {
      invoiceId: (a, b) =>
        filterOption.invoiceId
          ? a.invoiceId.localeCompare(b.invoiceId)
          : b.invoiceId.localeCompare(a.invoiceId),
      billingDate: (a, b) =>
        filterOption.billingDate
          ? new Date(a.date) - new Date(b.date)
          : new Date(b.date) - new Date(a.date),
      plan: (a, b) =>
        filterOption.plan
          ? a.plan.localeCompare(b.plan)
          : b.plan.localeCompare(a.plan),
      status: (a, b) =>
        filterOption.status
          ? a.status.localeCompare(b.status)
          : b.status.localeCompare(a.status),
      amount: (a, b) =>
        filterOption.amount
          ? Number(a.amount) - Number(b.amount)
          : Number(b.amount) - Number(a.amount),
    };

    if (sortFunctions[option]) {
      sortedData.sort(sortFunctions[option]);
      setInvoiceData(sortedData);
    }
  };

  const downloadInvoice = async (merchantTransactionId) => {
    try {
      const response = await axios.get(
        `${COMPANY_URLS.downloadPdf}?merchantTransactionId=${merchantTransactionId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            Accept: "application/json",
          },
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `invoice_${merchantTransactionId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      console.error("Error downloading invoice:", err);
    }
  };

  const handleDownloadAll = async () => {
    try {
      const downloadPromises = invoiceData.map((invoice) =>
        downloadInvoice(invoice.invoiceId)
      );

      await Promise.all(downloadPromises);
    } catch (err) {
      console.error("Error downloading all invoices", err);
    }
  };

  return (
    <div className="billingNinvoice_main">
      <h1>Billing & Invoice</h1>
      <div className="active-plan-card d-flex justify-content-between gap-md-4 gap-3">
        <div className="row d-flex flex-grow-1 justify-content-between pb-2">
          <div className="col-sm-5 col-md-5 leftSide-section">
            <p>Active Plan Info</p>
            <p>Activated Since</p>
            <h2>on {activePlan.activatedSince}</h2>
            <span>Expired on {activePlan.expiredAt}</span>
          </div>
          <div className="col-sm-5 col-md-5 d-flex flex-column align-items-sm-end justify-content-sm-end leftSide_wraper">
            <div className="d-flex align-items-center justify-content-sm-end mb-4">
              <div>
                <span>₹{activePlan.amount}</span>
                <span>/{activePlan.duration}</span>
              </div>  
            </div>
            <button>{activePlan.planName}</button>
          </div>
        </div>
        <div className="download_menuIcon">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="button-tooltip">Plan options</Tooltip>}
          >
            <BsThreeDotsVertical fontSize={28} color="#B9BEC1" />
          </OverlayTrigger>
        </div>
      </div>

      <div className="table_billing_dwn_section d-flex gap-2 px-3 px-md-0 mb-2 mt-5 flex-wrap">
        <div>
          <h1>Invoice</h1>
          <p>Effortlessly handle your billing and invoices right here.</p>
        </div>
        <div>
          <Button
            className="w-100"
            variant="primary"
            onClick={handleDownloadAll}
            disabled={invoiceData.length === 0}
          >
            Download All
          </Button>
        </div>
      </div>

      <div className="tnx_htry_table d-flex">
        <table>
          <thead>
            <tr>
              <th>
                <span
                  onClick={() => handleOptionToggle("invoiceId")}
                  className="make_res"
                >
                  Invoice ID{" "}
                  <BsCaretDownFill
                    className={`rorate ${
                      filterOption?.invoiceId && "rotate-active"
                    }`}
                    fontSize={14}
                  />
                </span>
              </th>
              <th>
                <span
                  onClick={() => handleOptionToggle("billingDate")}
                  className="make_res"
                >
                  Billing Date{" "}
                  <BsCaretDownFill
                    className={`rorate ${
                      filterOption?.billingDate && "rotate-active"
                    }`}
                    fontSize={14}
                  />
                </span>
              </th>
              <th>
                <span
                  onClick={() => handleOptionToggle("plan")}
                  className="make_res"
                >
                  Plan{" "}
                  <BsCaretDownFill
                    className={`rorate ${
                      filterOption?.plan && "rotate-active"
                    }`}
                    fontSize={14}
                  />
                </span>
              </th>
              <th>
                <span
                  onClick={() => handleOptionToggle("amount")}
                  className="make_res"
                >
                  Amount{" "}
                  <BsCaretDownFill
                    className={`rorate ${
                      filterOption?.amount && "rotate-active"
                    }`}
                    fontSize={14}
                  />
                </span>
              </th>
              <th>
                <span
                  onClick={() => handleOptionToggle("status")}
                  className="make_res"
                >
                  Status{" "}
                  <BsCaretDownFill
                    className={`rorate ${
                      filterOption?.status && "rotate-active"
                    }`}
                    fontSize={14}
                  />
                </span>
              </th>
              <th>
                <span className="make_res">Action</span>
              </th>
            </tr>
          </thead>
          <tbody>
          {!invoiceData.length && (
              <tr>
                <td colSpan="6" className="text-center">
                  {error ? (
                    <span className="text-danger">Error: {error}</span>
                  ) : (
                    "No invoice data available"
                  )}
                </td>
              </tr>
            )}
            {invoiceData?.map((data, idx) => (
              <tr key={idx}>
                <td>{data?.invoiceId}</td>
                <td>{data?.date}</td>
                <td>{data?.plan}</td>
                <td>₹{data?.amount}</td>
                <td>
                  <div className={`${data?.status.toLowerCase()}`}>
                    {data?.status}
                  </div>
                </td>
                <td>
                  <div
                    className="dwnld_btn"
                    onClick={() => downloadInvoice(data?.invoiceId)}
                  >
                    Download
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
